const CURRENT_PAGE_KEY = 'currentPage';
const ROWS_PER_PAGE_KEY = 'rowsPerPage';
const SORT_MODEL_KEY = 'sortModel';

const getCurrentPageKey = (pageKey: string): string => {
  return `${pageKey}_${CURRENT_PAGE_KEY}`;
};

const getRowsPerPageKey = (pageKey: string): string => {
  return `${pageKey}_${ROWS_PER_PAGE_KEY}`;
};

export const saveCurrentPageToLocalStorage = (pageKey: string, currentPage: number): void => {
  localStorage.setItem(getCurrentPageKey(pageKey), currentPage.toString());
};

export const saveRowsPerPageToLocalStorage = (pageKey: string, rowsPerPage: number): void => {
  localStorage.setItem(getRowsPerPageKey(pageKey), rowsPerPage.toString());
};

export const getSavedCurrentPage = (pageKey: string): number => {
  const stored = localStorage.getItem(getCurrentPageKey(pageKey));
  return stored ? parseInt(stored, 10) : 0;
};

export const getSavedRowsPerPage = (pageKey: string): number => {
  const stored = localStorage.getItem(getRowsPerPageKey(pageKey));
  return stored ? parseInt(stored, 10) : 15;
};

const getSortModelKey = (pageKey: string): string => {
  return `${pageKey}_${SORT_MODEL_KEY}`;
};

export const saveSortModelToLocalStorage = (
  pageKey: string,
  sortModel: readonly { field: string; sort: 'asc' | 'desc' | null | undefined }[],
): void => {
  localStorage.setItem(getSortModelKey(pageKey), JSON.stringify(sortModel));
};

export const getSavedSortModel = (
  pageKey: string,
): { field: string; sort: 'asc' | 'desc' | null | undefined }[] => {
  const stored = localStorage.getItem(getSortModelKey(pageKey));
  return stored ? JSON.parse(stored) : [];
};
